import * as React from 'react'

import { withTranslation } from 'react-i18next'

/* Import components here */
import { StyledCategoryList } from './CategoryList.styles'
import {
  StyledContainer,
  StyledList,
  StyledText,
  StyledWrapper,
  StyledCircleWrapper,
  StyledCircle,
  Content,
  Extra,
  Wrap
} from '../../../../utils/listSort/ListSort.styles'
/* Import interfaces here */
import { ICategoryListProps, ICategoryListState } from './CategoryList.interfaces'

/* Import utilities here */
import ListSort from '../../../../utils/listSort/ListSort'
import { Form, Input, Button, Icon } from 'antd'
import { withFirebase } from '../../../../firebase'
import { compose } from 'recompose'

let id = 9001
export class CategoryList extends React.Component<ICategoryListProps, ICategoryListState> {
  public state = {
    editing: false,
    categoryList: []
  }

  componentDidMount() {
    this.props.firebase
      .settings()
      .get()
      .then(doc => {
        if (doc.exists) {
          this.setState({ categoryList: doc.data().categories })
        } else {
          // doc.data() will be undefined in this case
          console.log('No such document!')
        }
      })
      .catch(error => {
        console.log('Error getting document:', error)
      })
  }

  toggleEditing = () => {
    this.setState({ editing: !this.state.editing })
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { keys, names } = values
        console.log('Received values of form: ', values)
        console.log(
          'Merged values:',
          keys.map(key => names[key])
        )
        /* console.log(
          'SETSTATE',
          Array.from(keys.sort(), (key: any) => names[key])
        ) */
        //this.setState({ priorityList: Array.from(keys.sort(), (key: any) => names[key]) })
        const namesField: any[] = []
        keys.forEach(k => {
          namesField[k] = names[k]
        })
        console.log('NAMEFIELD', namesField)
        // this.props.form.setFieldsValue({
        //   names: namesField
        // })
        this.setState({ categoryList: namesField })

        const categories = keys.map(key => names[key])
        console.log('Categories TO FIREBASE', categories)
        this.props.firebase
          .settings()
          .update({
            categories
          })
          .then(() => this.toggleEditing())
      }
    })
  }

  setKeys = objectArray => {
    const { form } = this.props
    const { categoryList, editing } = this.state
    if (Array.isArray(objectArray)) {
      form.setFieldsValue({
        keys: Array.from(objectArray, (x: any) => parseInt(x.key))
      })
      if (!editing) {
        const currentOrderList: any[] = []
        objectArray.forEach(k => {
          const i = parseInt(k.key)
          currentOrderList.push(categoryList[i])
        })
        this.props.firebase.settings().update({
          categories: currentOrderList
        })
      }
    }
  }

  add = () => {
    const { form } = this.props
    // can use data-binding to get
    const keys = form.getFieldValue('keys')
    const nextKeys = keys.concat(id++)
    // can use data-binding to set
    // important! notify form to detect changes
    form.setFieldsValue({
      keys: nextKeys
    })
  }

  remove = k => {
    const { form } = this.props
    // can use data-binding to get
    const keys = form.getFieldValue('keys')
    // We need at least one
    if (keys.length === 1) {
      return
    }
    // can use data-binding to set
    form.setFieldsValue({
      keys: keys.filter(key => key !== k)
    })
  }

  public render() {
    const { getFieldDecorator, getFieldValue } = this.props.form
    const { editing, categoryList } = this.state
    getFieldDecorator('keys', {
      initialValue: categoryList.map((x, index) => index)
    })
    const keys = getFieldValue('keys')
    const color = '#FF5500'
    const childrenToRender = keys.map((key, index) => {
      if (editing) {
        return (
          <StyledList key={key}>
            <StyledCircleWrapper>
              <StyledCircle>{index + 1}</StyledCircle>
            </StyledCircleWrapper>
            <StyledText>
              <Form.Item>
                {getFieldDecorator(`names[${key}]`, {
                  initialValue: categoryList[key],
                  validateTrigger: ['onChange', 'onBlur'],
                  rules: [
                    {
                      required: true,
                      whitespace: true,
                      message: 'Vänligen skriv in en kategori eller ta bort fält'
                    }
                  ]
                })(
                  <Input
                    placeholder="Kategori"
                    style={{ textAlign: 'center', marginRight: '8px', width: '80%' }}
                  />
                )}
                {keys.length > 1 ? (
                  <Icon
                    className="dynamic-delete-button"
                    type="minus-circle-o"
                    style={{ color }}
                    onClick={() => this.remove(key)}
                  />
                ) : null}
              </Form.Item>
            </StyledText>
          </StyledList>
        )
      }
      return (
        <StyledList key={key}>
          <StyledCircleWrapper>
            <StyledCircle>{index + 1}</StyledCircle>
          </StyledCircleWrapper>
          <StyledText>
            <h1 style={{ textAlign: 'center', margin: '5px', width: '80%' }}>
              {categoryList[key]}
            </h1>
          </StyledText>
        </StyledList>
      )
    })

    return (
      <StyledCategoryList>
        <Wrap>
          <Content>
            <h1>Ärende Kategorier</h1>
          </Content>
          <Extra>
            <Icon type="ordered-list" />
          </Extra>
        </Wrap>
        <StyledWrapper>
          <StyledContainer>
            <Form onSubmit={this.handleSubmit}>
              <ListSort
                onChange={this.setKeys}
                dragClassName="list-drag-selected"
                appearAnim={{ animConfig: { marginTop: [5, 30], opacity: [1, 0] } }}
              >
                {childrenToRender}
              </ListSort>
              {editing && (
                <>
                  <Form.Item style={{ marginBottom: '0px' }}>
                    <Button type="dashed" onClick={this.add} style={{ width: '100%' }}>
                      <Icon type="plus" /> Lägg till fält
                    </Button>
                    {/* <Button
                      disabled={keys.length < 2}
                      type="dashed"
                      onClick={this.remove}
                      style={{ width: '49%', marginLeft: '2%' }}
                    >
                      <Icon type="minus" /> Ta bort fält
                    </Button> */}
                  </Form.Item>
                  <Form.Item>
                    <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
                      Ändra
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form>
            {!editing && (
              <Button
                type="primary"
                style={{ width: '100%', marginTop: '20px' }}
                onClick={this.toggleEditing}
              >
                Editera
              </Button>
            )}
          </StyledContainer>
        </StyledWrapper>
      </StyledCategoryList>
    )
  }
}

const CategoryForm = Form.create({ name: 'Category' })(
  compose(withTranslation(), withFirebase)(CategoryList)
)

export default CategoryForm
